import { useSitecoreContext } from 'hooks/useSitecoreContext';
import Script from 'next/script';

const GTM = () => {
  const {
    sitecoreContext: { gtmConfigs },
  } = useSitecoreContext();

  return (
    <>
      {/* eslint-disable-next-line @next/next/no-before-interactive-script-outside-document */}
      <Script
        /* Ensure this is loaded before gtm script below. */
        strategy="beforeInteractive"
        id="consentModeScript"
        dangerouslySetInnerHTML={{
          __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    dataLayer.push(arguments);
                }
                gtag('consent', 'default', {
                    ad_storage: 'denied',
                    analytics_storage: 'denied',
                    functionality_storage: 'denied',
                    personalization_storage: 'denied',
                    security_storage: 'denied',
                    ad_user_data: 'denied',
                    ad_personalization: 'denied',
                    wait_for_update: 500,
                });
            `,
        }}
      />
      {gtmConfigs && gtmConfigs.length !== 0 && (
        <>
          {gtmConfigs.map((gtm) => (
            <Script
              key={`gtmScript-GTM-${gtm}`}
              id={`gtmScript-GTM-${gtm}`}
              dangerouslySetInnerHTML={{
                __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-${gtm}');`,
              }}
            />
          ))}
          {gtmConfigs.map((gtm) => (
            <noscript
              key={gtm + 'noscript'}
              id={gtm + 'script'}
              dangerouslySetInnerHTML={{
                __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-${gtm}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
              }}
            />
          ))}
        </>
      )}
    </>
  );
};

export default GTM;
